export const AssetType = {
  Pictogram: 'pictogram',
  Illustration: 'illustration',
  Icon: 'icon'
};